import { useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

export default function IntervieweeLanding(){
  const { linkId } = useParams();
  const [name,setName] = useState("");
  const [email,setEmail] = useState("");
  const [contact,setContact] = useState("");
  const navigate = useNavigate();

  const startInterview = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/sessions/${linkId}`, {
        interviewee_name: name,
        interviewee_email: email,
        contact
      });
      navigate(`/interviewee/chat/${res.data.session_id}`);
    } catch (err) {
      alert("Error starting interview");
    }
  };

  return (
    <div className="container">
      <div className="card" style={{maxWidth:640, margin:"24px auto"}}>
        <h2>Candidate Information</h2>
        <input className="input" placeholder="Name" onChange={e=>setName(e.target.value)} />
        <input className="input" placeholder="Email" onChange={e=>setEmail(e.target.value)} style={{marginTop:10}} />
        <input className="input" placeholder="Contact Info" onChange={e=>setContact(e.target.value)} style={{marginTop:10}} />
        <div style={{marginTop:12}}>
          <button className="btn" onClick={startInterview}>Start Interview</button>
        </div>
      </div>
    </div>
  );
}
